import { HoverCard, Text, Group, TextProps } from '@mantine/core';
import { toDateString } from '../utils/dates';

export const Date = ({
  isoString,
  textProps,
}: {
  isoString: string;
  textProps?: TextProps;
}) => {
  // respect passed in size but be opinionated about the default
  const { size } = textProps ? textProps : { size: 'sm' };
  return (
    <Group justify="center">
      <HoverCard width={250} shadow="md">
        <HoverCard.Target>
          <Text {...textProps} size={size}>
            {toDateString(isoString)}
          </Text>
        </HoverCard.Target>
        <HoverCard.Dropdown>
          <Text style={{ textAlign: 'center' }} size="sm">
            {isoString}
          </Text>
        </HoverCard.Dropdown>
      </HoverCard>
    </Group>
  );
};
